/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { Box } from '@zillow/constellation-10';
import { FunctionComponentWithChildren } from 'src/utils/types';

export const StyledErrorPage: FunctionComponentWithChildren = ({ children }) => (
    <Box
        css={{
            position: 'relative',
            width: '100%',
            backgroundColor: '{colors.blue.200}',
            margin: '0 auto',
            height: `calc({sizes.desktopHeight} + 200px)`,
        }}>
        {children}
    </Box>
);
